function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo } from 'react';
import classNames from 'classnames';
import { useCustomFieldOption } from '../../../common/hooks/useCustomField';
const Option = /*#__PURE__*/memo(({
  value,
  unclosable,
  disabled,
  className,
  onClick,
  children,
  ...props
}) => {
  const {
    selected,
    handleClick
  } = useCustomFieldOption({
    value,
    onClick
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames("select-option", {
      selected,
      unclosable,
      disabled
    }, className),
    "data-value": value,
    onClick: !disabled ? handleClick : undefined
  }, props), children);
});
Option.defaultProps = {
  selected: false
};
export default Option;